import {
  GET_DASHBOARD_NOTIFICATIONS,
  REMOVE_NOTIFICATION_REQUEST,
  INIT_DASHBOARD_NOTIFICATIONS,
  GET_EMPLOYEE_NOTIFICATIONS_SUCCESS,
  GET_EMPLOYEE_NOTIFICATIONS_FAIL
} from "actions/notificationActions";
import { isEmpty } from "lodash";
import messages from "components/messagesDescription";

const initialState = {
  notifications: [],
  employeeNotifications: null,
  error: null,
  isFetching: false
};

export const constructNotifications = (
  notifications = [],
  passwordInfo = {},
  healthDeclarationForm = {}
) => {
  const result = notifications.map((notification, index) => {
    if (notification.notify && !isEmpty(notification.message)) {
      let linkTo = "";
      let targetType = "";
      switch (notification.id) {
        case "AdditionOfSpouse":
          linkTo = "/dependants/add";
          break;
        case "MissingDataInEmployeeProfile":
          linkTo = "/userProfile";
          break;
        case "IncompleteHDF":
          if (
            healthDeclarationForm.status === "Required" ||
            healthDeclarationForm.status === "Incomplete"
          ) {
            linkTo = `/hdf/${healthDeclarationForm.form.id}`;
            targetType = "_blank";
            break;
          } else {
            return null;
          }
        case "PasswordNearExpiry":
          if (passwordInfo && passwordInfo.showChangePasswordAlert) {
            return {
              ...notification,
              target: targetType,
              messageDescription: {
                id: notification.id,
                defaultMessage: notification.message,
              },
              messageValue: {
                passwordExpireInDays: passwordInfo.passwordExpireInDays,
              },
              link: "/changePassword",
              linkTextDescription: { ...messages.changePasswordNowDescription },
              keyId: index,
            };
          }
          return null;
        default:
          break;
      }
      return {
        ...notification,
        target: targetType,
        link: linkTo,
        linkTextDescription: {
          id: notification.message,
          defaultMessage: notification.message,
        },
        keyId: index,
      };
    }
    return null;
  });

  return result.filter(n => n);
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_DASHBOARD_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload,
      };
    }
    case GET_DASHBOARD_NOTIFICATIONS: {
      const { byId } = action.payload;
      return {
        ...state,
        notifications: constructNotifications(
          byId["Notifications"],
          byId["PasswordInfo"],
          byId["HealthDeclarationForm"]
        ),
      };
    }
    case REMOVE_NOTIFICATION_REQUEST: {
      return {
        ...state,
        notifications: state.notifications.filter(
          notification =>
            !(notification.dismissable && notification.id === action.payload)
        ),
      };
    }
    case GET_EMPLOYEE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        employeeNotifications: action.payload
      };
    case GET_EMPLOYEE_NOTIFICATIONS_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        employeeNotifications: null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/notificationReducer.jsx